/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 44);
/******/ })
/************************************************************************/
/******/ ({

/***/ 3:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var smoothscroll = __webpack_require__(45);
var gumshoe = __webpack_require__(46);
var heroBlocksPosition = [];
var resizeTimer = null;
var heroBlocks = Array.prototype.slice.call(document.querySelectorAll(".hero-block"));
var homeBlockNavLink = null;
var titles = Array.prototype.slice.call(document.querySelectorAll(".hero-title"));
var titlesInnerHTML = [];
// For IE and Edge
smoothscroll.polyfill();
window.addEventListener("DOMContentLoaded", function () {
    titles.forEach(function (title) {
        titlesInnerHTML.push(title.innerHTML);
    });
    truncateLongTitles();
    if (document.querySelector(".scrollspy-dot-navbar")) {
        var navbarContainer = document.querySelectorAll('.scrollspy-dot-navbar')[0];
        // Find all sections to add to scrollspy nav list
        var jumpSections = Array.prototype.slice.call(document.querySelectorAll('[data-scrollspy="true"]'));
        var jumpList_1 = '';
        // Create list item by looping through each section
        jumpSections.forEach(function (section) {
            var sectionTarget = section.id;
            jumpList_1 += "<li><a data-scroll-ignore href=\"#" + sectionTarget + "\"></a></li>";
        });
        // Add string of list items to scrollspy nav
        var jumpListContainer = navbarContainer.querySelectorAll('nav ul')[0];
        jumpListContainer.innerHTML = jumpList_1;
        // Handler when the DOM is fully loaded
        initGumshoe();
    }
    ;
    heroBlocks.forEach(function (block) {
        var blockPosition = block.offsetTop - block.scrollTop + block.clientTop;
        heroBlocksPosition.push(blockPosition);
    });
    var homeBlockNav = Array.prototype.slice.call(document.querySelector(".home-page-nav").querySelectorAll("li"));
    var _loop_1 = function (i) {
        homeBlockNav[i].querySelector("a").addEventListener("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: heroBlocksPosition[i], left: 0, behavior: 'smooth' });
        });
    };
    for (var i = 0; i < homeBlockNav.length; i++) {
        _loop_1(i);
    }
});
window.addEventListener("resize", function () {
    if (resizeTimer != null) {
        clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function () {
        heroBlocksPosition = [];
        heroBlocks.forEach(function (block) {
            var blockPosition = block.offsetTop - block.scrollTop + block.clientTop;
            heroBlocksPosition.push(blockPosition);
        });
        initGumshoe();
    }, 500);
    truncateLongTitles();
});
function addActiveClass() {
    var activeHeroBlockId = document.querySelector("a.home-page-nav-active").getAttribute("href");
    var activeHeroBlock = document.querySelector(activeHeroBlockId);
    var heroTintOverlay = activeHeroBlock.querySelector(".hero-tint-overlay");
    var heroContent = activeHeroBlock.querySelector(".hero-content");
    if (!heroTintOverlay.classList.contains("hero-tint-overlay-show")) {
        heroTintOverlay.classList.add("hero-tint-overlay-show");
    }
    if (!heroContent.classList.contains("hero-content-show")) {
        heroContent.classList.add("hero-content-show");
    }
}
function truncateLongTitles() {
    for (var i = 0; i < titles.length; i++) {
        titles[i].innerHTML = titlesInnerHTML[i];
        if (window.innerWidth <= 1600 && window.innerWidth > 1280) {
            // Upperbound is equal to 2 times the title font-size at this breakpoint
            // This prevents the title from ever wrapping over 2 lines
            if (titles[i].clientHeight > 432) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
        if (window.innerWidth <= 1280 && window.innerWidth > 1025) {
            if (titles[i].clientHeight > 320) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
        if (window.innerWidth <= 1025) {
            if (titles[i].clientHeight > 240) {
                titles[i].innerHTML = titles[i].innerHTML.substring(0, 18) + "...";
            }
            else {
                titles[i].innerHTML = titlesInnerHTML[i];
            }
        }
    }
}
function initGumshoe() {
    gumshoe.init({
        selector: '[data-gumshoe] a',
        //selectorHeader: '#siteHeader', // Fixed header selector (must use a valid CSS selector)
        container: window,
        offset: 250,
        activeClass: 'home-page-nav-active',
        scrollDelay: false,
        callback: function (nav) {
            addActiveClass();
        } // Callback to run after setting active link
    });
}


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      while (el !== d.body && isScrollable(el) === false) {
        el = el.parentNode || el.host;
      }

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;﻿/*!
 * gumshoe v3.5.0: A simple, framework-agnostic scrollspy script.
 * (c) 2017 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/gumshoe
 */

(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory(root)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(root);
    } else {
        root.gumshoe = factory(root);
    }
})(typeof global !== 'undefined' ? global : this.window || this.global, (function (root) {

    'use strict';

    //
    // Variables
    //

    var gumshoe = {}; // Object for public APIs
    var supports = 'querySelector' in document && 'addEventListener' in root && 'classList' in document.createElement('_'); // Feature test
    var navs = []; // Array for nav elements
    var settings, eventTimeout, docHeight, header, headerHeight, currentNav, scrollEventDelay;

    // Default settings
    var defaults = {
        selector: '[data-gumshoe] a',
        selectorHeader: '[data-gumshoe-header]',
        container: root,
        offset: 0,
        activeClass: 'active',
        scrollDelay: false,
        callback: function () { }
    };


    //
    // Methods
    //

	/**
	 * A simple forEach() implementation for Arrays, Objects and NodeLists.
	 * @private
	 * @author Todd Motto
	 * @link   https://github.com/toddmotto/foreach
	 * @param {Array|Object|NodeList} collection Collection of items to iterate
	 * @param {Function}              callback   Callback function for each iteration
	 * @param {Array|Object|NodeList} scope      Object/NodeList/Array that forEach is iterating over (aka `this`)
	 */
    var forEach = function (collection, callback, scope) {
        if (Object.prototype.toString.call(collection) === '[object Object]') {
            for (var prop in collection) {
                if (Object.prototype.hasOwnProperty.call(collection, prop)) {
                    callback.call(scope, collection[prop], prop, collection);
                }
            }
        } else {
            for (var i = 0, len = collection.length; i < len; i++) {
                callback.call(scope, collection[i], i, collection);
            }
        }
    };

	/**
	 * Merge two or more objects. Returns a new object.
	 * @private
	 * @param {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
	 * @param {Object}   objects  The objects to merge together
	 * @returns {Object}          Merged values of defaults and options
	 */
    var extend = function () {

        // Variables
        var extended = {};
        var deep = false;
        var i = 0;
        var length = arguments.length;

        // Check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
            deep = arguments[0];
            i++;
        }

        // Merge the object into the extended object
        var merge = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    // If deep merge and property is an object, merge properties
                    if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
                        extended[prop] = extend(true, extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for (; i < length; i++) {
            var obj = arguments[i];
            merge(obj);
        }

        return extended;

    };

	/**
	 * Get the height of an element.
	 * @private
	 * @param  {Node} elem The element to get the height of
	 * @return {Number}    The element's height in pixels
	 */
    var getHeight = function (elem) {
        return Math.max(elem.scrollHeight, elem.offsetHeight, elem.clientHeight);
    };

	/**
	 * Get the document element's height
	 * @private
	 * @returns {Number}
	 */
    var getDocumentHeight = function () {
        return Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
    };

	/**
	 * Get an element's distance from the top of the Document.
	 * @private
	 * @param  {Node} elem The element
	 * @return {Number}    Distance from the top in pixels
	 */
    var getOffsetTop = function (elem) {
        var location = 0;
        if (elem.offsetParent) {
            do {
                location += elem.offsetTop;
                elem = elem.offsetParent;
            } while (elem);
        } else {
            location = elem.offsetTop;
        }
        location = location - headerHeight - settings.offset;
        return location >= 0 ? location : 0;
    };

	/**
	 * Determine if an element is in the viewport
	 * @param  {Node}    elem The element
	 * @return {Boolean}      Returns true if element is in the viewport
	 */
    var isInViewport = function (elem) {
        var distance = elem.getBoundingClientRect();
        return (
            distance.top >= 0 &&
            distance.left >= 0 &&
            distance.bottom <= (root.innerHeight || document.documentElement.clientHeight) &&
            distance.right <= (root.innerWidth || document.documentElement.clientWidth)
        );
    };

	/**
	 * Arrange nagivation elements from furthest from the top to closest
	 * @private
	 */
    var sortNavs = function () {
        navs.sort((function (a, b) {
            if (a.distance > b.distance) {
                return -1;
            }
            if (a.distance < b.distance) {
                return 1;
            }
            return 0;
        }));
    };

	/**
	 * Calculate the distance of elements from the top of the document
	 * @public
	 */
    gumshoe.setDistances = function () {

        // Calculate distances
        docHeight = getDocumentHeight(); // The document
        headerHeight = header ? (getHeight(header) + getOffsetTop(header)) : 0; // The fixed header
        forEach(navs, (function (nav) {
            nav.distance = getOffsetTop(nav.target); // Each navigation target
        }));

        // When done, organization navigation elements
        sortNavs();

    };

	/**
	 * Get all navigation elements and store them in an array
	 * @private
	 */
    var getNavs = function () {

        // Get all navigation links
        var navLinks = document.querySelectorAll(settings.selector);

        // For each link, create an object of attributes and push to an array
        forEach(navLinks, (function (nav) {
            if (!nav.hash) return;
            var target = document.querySelector(nav.hash);
            if (!target) return;
            navs.push({
                nav: nav,
                target: target,
                parent: nav.parentNode.tagName.toLowerCase() === 'li' ? nav.parentNode : null,
                distance: 0
            });
        }));

    };


	/**
	 * Remove the activation class from the currently active navigation element
	 * @private
	 */
    var deactivateCurrentNav = function () {
        if (currentNav) {
            currentNav.nav.classList.remove(settings.activeClass);
            if (currentNav.parent) {
                currentNav.parent.classList.remove(settings.activeClass);
            }
        }
    };

	/**
	 * Add the activation class to the currently active navigation element
	 * @private
	 * @param  {Node} nav The currently active nav
	 */
    var activateNav = function (nav) {

        // If a current Nav is set, deactivate it
        deactivateCurrentNav();

        // Activate the current target's navigation element
        nav.nav.classList.add(settings.activeClass);
        if (nav.parent) {
            nav.parent.classList.add(settings.activeClass);
        }

        settings.callback(nav); // Callback after methods are run

        // Set new currentNav
        currentNav = {
            nav: nav.nav,
            parent: nav.parent
        };

    };

	/**
	 * Determine which navigation element is currently active and run activation method
	 * @public
	 * @returns {Object} The current nav data.
	 */
    gumshoe.getCurrentNav = function () {

        // Get current position from top of the document
        var position = root.pageYOffset;

        // If at the bottom of the page and last section is in the viewport, activate the last nav
        if ((root.innerHeight + position) >= docHeight && isInViewport(navs[0].target)) {
            activateNav(navs[0]);
            return navs[0];
        }

        // Otherwise, loop through each nav until you find the active one
        for (var i = 0, len = navs.length; i < len; i++) {
            var nav = navs[i];
            if (nav.distance <= position) {
                activateNav(nav);
                return nav;
            }
        }

        // If no active nav is found, deactivate the current nav
        deactivateCurrentNav();
        settings.callback();

    };

	/**
	 * If nav element has active class on load, set it as currently active navigation
	 * @private
	 */
    var setInitCurrentNav = function () {
        forEach(navs, (function (nav) {
            if (nav.nav.classList.contains(settings.activeClass)) {
                currentNav = {
                    nav: nav.nav,
                    parent: nav.parent
                };
            }
        }));
    };

	/**
	 * Destroy the current initialization.
	 * @public
	 */
    gumshoe.destroy = function () {

        // If plugin isn't already initialized, stop
        if (!settings) return;

        // Remove event listeners
        settings.container.removeEventListener('resize', eventThrottler, false);
        settings.container.removeEventListener('scroll', eventThrottler, false);

        // Reset variables
        navs = [];
        settings = null;
        eventTimeout = null;
        docHeight = null;
        header = null;
        headerHeight = null;
        currentNav = null;
        scrollEventDelay = null;

    };

	/**
	 * Run functions after scrolling stops
	 * @param  {[type]} event [description]
	 * @return {[type]}       [description]
	 */
    var scrollStop = function (event) {

        // Clear our timeout throughout the scroll
        window.clearTimeout(eventTimeout);

        // recalculate distances and then get currently active nav
        eventTimeout = setTimeout((function () {
            gumshoe.setDistances();
            gumshoe.getCurrentNav();
        }), 66);

    };

	/**
	 * On window scroll and resize, only run events at a rate of 15fps for better performance
	 * @private
	 * @param  {Function} eventTimeout Timeout function
	 * @param  {Object} settings
	 */
    var eventThrottler = function (event) {
        if (!eventTimeout) {
            eventTimeout = setTimeout((function () {

                eventTimeout = null; // Reset timeout

                // If scroll event, get currently active nav
                if (event.type === 'scroll') {
                    gumshoe.getCurrentNav();
                }

                // If resize event, recalculate distances and then get currently active nav
                if (event.type === 'resize') {
                    gumshoe.setDistances();
                    gumshoe.getCurrentNav();
                }

            }), 66);
        }
    };

	/**
	 * Initialize Plugin
	 * @public
	 * @param {Object} options User settings
	 */
    gumshoe.init = function (options) {

        // feature test
        if (!supports) return;

        // Destroy any existing initializations
        gumshoe.destroy();

        // Set variables
        settings = extend(defaults, options || {}); // Merge user options with defaults
        header = document.querySelector(settings.selectorHeader); // Get fixed header
        getNavs(); // Get navigation elements

        // If no navigation elements exist, stop running gumshoe
        if (navs.length === 0) return;

        // Run init methods
        setInitCurrentNav();
        gumshoe.setDistances();
        gumshoe.getCurrentNav();

        // Listen for events
        settings.container.addEventListener('resize', eventThrottler, false);
        if (settings.scrollDelay) {
            settings.container.addEventListener('scroll', scrollStop, false);
        } else {
            settings.container.addEventListener('scroll', eventThrottler, false);
        }

    };


    //
    // Public APIs
    //

    return gumshoe;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

/******/ });


// WEBPACK FOOTER //
// home-bundle.js